<template>
  <div class="links-cell-renderer d-flex gap-3">
    <a
      v-for="link in params.links"
      :key="link.url"
      :href="link.url"
    >
      {{ link.text }}
    </a>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)
</script>
